export const updatedobj=(oldstate,newvaluetostate)=>{
    return{
        ...oldstate,
        ...newvaluetostate
    }
}


// WEBPACK FOOTER //
// ./src/store/utility.js